<template>
  <svg width="24px" height="24px"
       viewBox="0 0 24 24" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>atoms/icons/24x24/time/black</title>
    <g id="atoms/icons/24x24/time/black" stroke="none"
       stroke-width="1"
       fill-rule="evenodd">
      <path d="M12,3.2 C16.8601058,3.2 20.8,7.1398942 20.8,12 C20.8,16.8601058 16.8601058,20.8 12,20.8 C7.1398942,20.8 3.2,16.8601058 3.2,12 C3.2,7.1398942 7.1398942,3.2 12,3.2 Z M12,4.8 C8.0235498,4.8 4.8,8.0235498 4.8,12 C4.8,15.9764502 8.0235498,19.2 12,19.2 C15.9764502,19.2 19.2,15.9764502 19.2,12 C19.2,8.0235498 15.9764502,4.8 12,4.8 Z M12,6.4 C12.4418278,6.4 12.8,6.7581722 12.8,7.2 L12.8,11.6064 L15.0494053,14.7328033 C15.2875828,15.063871 15.2363942,15.5153049 14.9450166,15.7857414 L14.8671967,15.8494053 C14.50854,16.1074309 14.0086203,16.0258533 13.7505947,15.6671967 L11.3505947,12.3311864 C11.2526788,12.1950829 11.2,12.0316552 11.2,11.8639898 L11.2,7.2 C11.2,6.7581722 11.5581722,6.4 12,6.4 Z" id="Combined-Shape"
            fill-rule="nonzero"></path>
    </g>
  </svg>
</template>
<script setup>
// dummy comment to surpress rollup build errors with dynamic imports
// if the file doesn't contain a script tag with content, the build fails.
</script>
